import AnchorLink from 'anchor-link';
import AnchorLinkBrowserTransport from 'anchor-link-browser-transport';
import wax, { ensureWaxApi } from '../wax';
import { nameToUint64 } from 'eosjs-account-name';
import NFT_TEMPLATES from '../config/nftTemplates';
const main_account = "ranchersland";
const token_account = "ranchersbank";

const transport = new AnchorLinkBrowserTransport();
const link = new AnchorLink({
  transport,
  chains: [
    {
      chainId: "1064487b3cd1a897ce03ae5b6a865651747e2e152090f99c1d19d44e01aea5a4",
      nodeUrl: "https://wax.greymass.com",
    },
    {
      chainId: "f16b1833c747c43682f4386fca9cbb327929334a762755ebec17f6f23c9b8a12",
      nodeUrl: "https://waxtestnet.greymass.com",
    },
  ],
});

const WAX_ENDPOINTS = [
  //"https://apiwax.3dkrender.com",
  //"https://query.3dkrender.com",
  "https://api.wax.alohaeos.com",
  "https://wax.blacklusion.io",
  "https://api.wax.bountyblok.io",
  "https://wax.a-dex.xyz",
  "https://wax-api.alcor.exchange",
  "https://api-wax-mainnet.wecan.dev",
  "https://history-wax-mainnet.wecan.dev",
  "https://hyperion-wax-mainnet.wecan.dev",
  "https://wax.cryptolions.io",
  "https://wax.dapplica.io",
  "https://wax.eosphere.io",
  //"https://wax.eosrio.io",
  "https://api.wax.greeneosio.com",
  "https://wax-public1.neftyblocks.com",
  "https://wax-public2.neftyblocks.com",
  "https://api-wax.tacocrypto.io",
  "https://api.waxdaobp.io",
  "https://wax.eosusa.io",
  "https://waxapi.ledgerwise.io",
  //"https://api.wax.liquidstudios.io",
  "https://wax.api.eosnation.io",
  "https://wax.pink.gg",
  "https://wax.qaraqol.com",
  //"https://wax.greymass.com",
  "https://api.waxeastern.cn",
  "https://api2.hivebp.io",
  "https://api.hivebp.io",
  "https://wax.hivebp.io",
  "https://wax-api.eosiomadrid.io",
  "https://api.waxsweden.org",
  "https://history.waxsweden.org",
  "https://wax-rpc.wombat.app",
];

const WAX_TESTNET_ENDPOINTS = [
  // "http://testnet.waxsweden.org",
  // "http://api.waxtest.alohaeos.com",
  // "http://wax-testnet.dapplica.io",
  // "http://wax-testnet.eosphere.io",
  "https://testnet.waxsweden.org",
  "https://api.waxtest.alohaeos.com",
  "https://wax-testnet.dapplica.io",
  "https://wax-testnet.eosphere.io"
];



const getRandomEndpoint = () => {
  const index = Math.floor(Math.random() * WAX_ENDPOINTS.length);
  return WAX_ENDPOINTS[index];
};

const fetchTable = async (payload, maxTries = 5) => {
  let tries = 0;

  while (tries < maxTries) {
    const endpoint = getRandomEndpoint();
    const url = `${endpoint}/v1/chain/get_table_rows`;

    try {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 3000); // 3 saniye timeout

      const res = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
        signal: controller.signal
      });

      clearTimeout(timeout);

      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const json = await res.json();

      if (json?.rows !== undefined) return json;

    } catch (err) {
      console.warn(`[fetchTable] ${endpoint} failed: ${err.message}`);
      tries++;
    }
  }

  throw new Error("All endpoints failed");
};


const getTransactionLog = async (trxId) => {
  const MAX_RETRIES = 2;
  const DELAY_MS = 500;

  const endpoints = [
    "https://history.waxsweden.org",
    "https://history-wax-mainnet.wecan.dev",
    //"https://apiwax.3dkrender.com",
    //"https://query.3dkrender.com",
    "https://api.wax.alohaeos.com",
    "https://wax.blacklusion.io",
    "https://api.wax.bountyblok.io",
    "https://wax.a-dex.xyz",
    "https://wax-api.alcor.exchange",
    "https://api-wax-mainnet.wecan.dev",
    "https://hyperion-wax-mainnet.wecan.dev",
    "https://wax.cryptolions.io",
    "https://wax.dapplica.io",
    "https://wax.eosphere.io",
    //"https://wax.eosrio.io",
    "https://api.wax.greeneosio.com",
    "https://wax-public1.neftyblocks.com",
    "https://wax-public2.neftyblocks.com",
    "https://api-wax.tacocrypto.io",
    "https://api.waxdaobp.io",
    "https://wax.eosusa.io",
    "https://waxapi.ledgerwise.io",
    //"https://api.wax.liquidstudios.io",
    "https://wax.api.eosnation.io",
    "https://wax.pink.gg",
    "https://wax.qaraqol.com",
    //"https://wax.greymass.com",
    "https://api.waxeastern.cn",
    "https://api2.hivebp.io",
    "https://api.hivebp.io",
    "https://wax.hivebp.io",
    "https://wax-api.eosiomadrid.io",
    "https://api.waxsweden.org",
    "https://wax-rpc.wombat.app",

  ];

  for (let attempt = 1; attempt <= MAX_RETRIES; attempt++) {
    // for (const endpoint of endpoints) {
    for(const endpoint of endpoints){
      try {
        await new Promise(resolve => setTimeout(resolve, DELAY_MS));

        const response = await fetch(`${endpoint}/v2/history/get_transaction?id=${trxId}`);
        const data = await response.json();

        if (data?.executed) {
          const notifyAction = data.actions?.find(a => a?.act?.name === "notify");
          const logInfo = notifyAction?.act?.data?.info;

          if (Array.isArray(logInfo)) return logInfo.join("\n");

          return logInfo || "Transaction Completed\nSuccessfully";
        }

      } catch (err) {
        console.warn(`[${endpoint}] Attempt ${attempt} failed`, err.message);
      }
    }
  }

  return "Transaction not found or not indexed after multiple attempts.";
};

let cachedSeasonData = null;
export const getSeasonTable = async () => {
  if (cachedSeasonData) {
    return cachedSeasonData;
  }
  try {
    const result = await fetchTable({
      json: true,
      code: main_account,
      scope: main_account,
      table: "seasoncon",
      reverse: false,
      show_payer: false
    });

    const defaultSeason = {
      stamina_cost: 0,
      durability_cost: 0,
      cooldown_multiplier: 0,
      reward_multiplier: 0,
      weights: { spring: 0, summer: 0, autumn: 0, winter: 0 },
      icon: require('../assets/icons/craft.webp')
    };

    const SEASONS = [
      { id: 1, session_name: 'spring', color: '#6fdc4f', ...defaultSeason },
      { id: 2, session_name: 'summer', color: '#f9d423', ...defaultSeason },
      { id: 3, session_name: 'autumn', color: '#f78e2c', ...defaultSeason },
      { id: 4, session_name: 'winter', color: '#9dddf9', ...defaultSeason }
    ];

    if (result?.rows?.length > 0) {
      const dataMap = new Map(result.rows.map(row => [row.session_name, row]));

      SEASONS.forEach(season => {
        const data = dataMap.get(season.session_name);
        if (data) {
          Object.assign(season, {
            stamina_cost: data.stamina_cost,
            durability_cost: data.durability_cost,
            cooldown_multiplier: data.cooldown_multiplier,
            reward_multiplier: data.reward_multiplier,
            weights: {
              spring: data.spring_w,
              summer: data.summer_w,
              autumn: data.autumn_w,
              winter: data.winter_w
            }
          });
        }
      });
    }
    cachedSeasonData = SEASONS;
    return SEASONS;
  } catch (err) {
    console.error(`[getSeasonTable] Error:`, err);
    return null;
  }
};

export const getUserHealerData = async(wallet) => {
  try{
    const result = await fetchTable({
      json: true,
      code: main_account,
      scope: main_account,
      table: "healdata",
      lower_bound: wallet,
      upper_bound: wallet,
      limit: 1,
      reverse: false,
      show_payer: false
    });
    if (result && result.rows && result.rows.length > 0) {
      return result.rows[0];
    }
    else return null;
  }
  catch(err){
    console.error(`[getUserHealerData] Error:`, err);
    return null;
  }
};


// ✅ Kullanıcıya ait accounts tablosunu çek
export const getplayerTable = async (wallet) => {
  try {
    const result = await fetchTable({
      json: true,
      code: main_account,
      scope: main_account,
      table: "accounts",
      lower_bound: wallet,
      upper_bound: wallet,
      limit: 1,
      reverse: false,
      show_payer: false
    });

    if (result?.rows?.length > 0) {
      return result.rows[0];
    } else {
      return null;
    }
  } catch (err) {
    console.error(`[getplayerTable] Error:`, err);
    return null;
  }
};

// ✅ Kullanıcıya ait referans tablosunu çek
export const getnetworkTable = async (wallet) => {
  try {
    const result = await fetchTable({
      json: true,
      code: main_account,
      scope: main_account,
      table: "network",
      lower_bound: wallet,
      upper_bound: wallet,
      limit: 1,
      reverse: false,
      show_payer: false
    });

    if (result?.rows?.length > 0) {
      return result.rows[0];
    } else {
      return null;
    }
  } catch (err) {
    console.error(`[getnetworkTable] Error:`, err);
    return null;
  }
};

export const getNetworkEarnings = async (acc) => {
  const wallet = localStorage.getItem("loggedInUser");
  const loginmethod = localStorage.getItem("loginMethod");

  if (!wallet || !loginmethod) {
    console.error("Need Login");
    return null;
  }

  try {
    const result = await fetchTable({
      json: true,
      code: main_account,
      scope: wallet,
      table: "invites",
      lower_bound: acc,
      upper_bound: acc,
      limit: 1,
      reverse: false,
      show_payer: false
    });

    if (result?.rows?.length > 0) {
      return result.rows[0];
    } else {
      return null;
    }
  } catch (err) {
    console.error(`[getNetworkEarnings] Error:`, err);
    return null;
  }
};

// ✅ Kullanıcıya ait accounts tablosunu çek
export const getplayerTools = async (asset_id) => {
  try {
    const result = await fetchTable({
      json: true,
      code: main_account,
      scope: main_account,
      table: "stakednft",
      lower_bound: asset_id,
      upper_bound: asset_id,
      limit: 1,
      reverse: false,
      show_payer: false
    });

    if (result && result.rows && result.rows.length > 0) {
      return result.rows[0]; // sadece tek kayıt gelir, doğrudan dön
    } else {
      return null;
    }
  } catch (err) {
    console.error(`[getStakedTable] Error for wallet ${asset_id}:`, err);
    return null;
  }
};

export const fetchDecayData = async (targetWallet = null) => {
  try {
    const wallet = targetWallet || localStorage.getItem("loggedInUser");
    const encryptedWallet = nameToUint64(wallet);
    const allRows = [];
    let lowerBound = encryptedWallet;
    let hasMore = true;

    while (hasMore) {
      const result = await fetchTable({
        json: true,
        code: main_account,
        scope: main_account,
        table: "nftdecay",
        key_type: "i64",
        index_position: 2,
        lower_bound: lowerBound,
        upper_bound: encryptedWallet,
        limit: 1000,
        reverse: false,
        show_payer: false
      });

      if (result?.rows?.length > 0) {
        allRows.push(...result.rows);
      }

      hasMore = result.more && result.next_key;
      if (hasMore) {
        lowerBound = result.next_key;
      }
    }

    console.log('Decay Data', allRows);
    return allRows;

  } catch (err) {
    console.error(`[fetchDecayData] Error for wallet ${targetWallet || 'loggedInUser'}:`, err);
    return [];
  }
};

// ✅ Enhanced function to get player tools with decay data
export const getplayerToolsWithDecayData = async (assetIds, targetWallet = null) => {
  try {
    if (!assetIds || assetIds.length === 0) {
      return [];
    }

    // First fetch decay data for the specific wallet
    const decayData = await fetchDecayData(targetWallet);

    // Fetch staked NFT data from game contract
    const stakedData = await Promise.all(
      (Array.isArray(assetIds) ? assetIds : []).map(async (assetId) => {
        const result = await fetchTable({
          json: true,
          code: main_account,
          scope: main_account,
          table: "stakednft",
          lower_bound: assetId,
          upper_bound: assetId,
          limit: 1,
          reverse: false,
          show_payer: false
        });
        return result?.rows?.[0] || null;
      })
    );

    // Combine staked data with decay data
    const combinedData = stakedData.filter(Boolean).map(staked => {
      const decay = decayData.find(d => d.asset_id === staked.asset_id);
      return {
        ...staked,
        decay_data: decay || { asset_id: staked.asset_id, decay_hr: 336 } // Default full health
      };
    });

    console.log(`[getplayerToolsWithDecayData] Combined ${combinedData.length} tools with decay data for wallet ${targetWallet || 'loggedInUser'}`);
    return combinedData;

  } catch (err) {
    console.error(`[getplayerToolsWithDecayData] Error:`, err);
    return [];
  }
};

export const getplayerWorkers = async (asset_id) => {
  try {
    const result = await fetchTable({
      json: true,
      code: main_account,
      scope: main_account,
      table: "stakedworker",
      lower_bound: asset_id,
      upper_bound: asset_id,
      limit: 1,
      reverse: false,
      show_payer: false
    });

    if (result && result.rows && result.rows.length > 0) {
      return result.rows[0]; // sadece tek kayıt gelir, doğrudan dön
    } else {
      return null;
    }
  } catch (err) {
    console.error(`[getStakedWorkerTable] Error for wallet ${asset_id}:`, err);
    return null;
  }
};

// ✅ Enhanced function to get player workers with decay data
export const getplayerWorkersWithDecayData = async (assetIds, targetWallet = null) => {
  try {
    if (!assetIds || !Array.isArray(assetIds) || assetIds.length === 0) {
      return [];
    }

    // First fetch decay data for the specific wallet
    const decayData = await fetchDecayData(targetWallet);

    // Fetch staked worker data from game contract
    const stakedData = await Promise.all(
      (Array.isArray(assetIds) ? assetIds : []).map(async (assetId) => {
      const result = await fetchTable({
        json: true,
        code: main_account,
        scope: main_account,
        table: "stakedworker",
        lower_bound: assetId,
        upper_bound: assetId,
        limit: 1,
        reverse: false,
        show_payer: false
      });
      return result?.rows?.[0] || null;
      })
    );

    // Combine staked data with decay data
    const combinedData = stakedData.filter(Boolean).map(staked => {
      const decay = decayData.find(d => d.asset_id === staked.asset_id);
      return {
        ...staked,
        decay_data: decay || { asset_id: staked.asset_id, decay_hr: 336 } // Default full health
      };
    });

    console.log(`[getplayerWorkersWithDecayData] Combined ${combinedData.length} workers with decay data for wallet ${targetWallet || 'loggedInUser'}`);
    return combinedData;

  } catch (err) {
    console.error(`[getplayerWorkersWithDecayData] Error:`, err);
    return [];
  }
};

const getRandomizedEndpoints = () => {
  const shuffled = [...WAX_ENDPOINTS];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};

export const getTokenBalance = async (token_account, account, symbol, maxTries = 8) => {
  const endpoints = getRandomizedEndpoints();

  for (let i = 0; i < Math.min(endpoints.length, maxTries); i++) {
    const endpoint = endpoints[i];
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 3000);

    try {
      const res = await fetch(`${endpoint}/v1/chain/get_currency_balance`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          code: token_account,
          account: account,
          symbol: symbol
        }),
        signal: controller.signal
      });

      clearTimeout(timeout);

      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const json = await res.json();

      if (json?.length > 0) return json[0];
      return `0.0000 ${symbol}`;

    } catch (err) {
      console.warn(`[getTokenBalance] ${endpoint} failed: ${err.message}`);
    }
  }

  return `0.0000 ${symbol}`; // Tüm node’lar çökerse default dön
};

export const getConfigs = async () => {
  try {
    const result = await fetchTable({
      json: true,
      code: main_account,
      scope: main_account,
      table: "config",
      limit: 1,
      reverse: false,
      show_payer: false
    });

    if (result && result.rows && result.rows.length > 0) {
      return result.rows[0]; // sadece tek kayıt gelir, doğrudan dön
    } else {
      return null;
    }
  } catch (err) {
    console.error(`[getconfig] Error for config :`, err);
    return null;
  }
};


export const getAtomicInventory = async (wallet) => {
  try {
    let result = await fetchTable({
      json: true, // Get the response as json
      code: "atomicassets", // Contract that we target
      scope: wallet, // Account that owns the data
      limit: 1000,
      table: "assets",
      reverse: false, // Optional: Get reversed data
      show_payer: false, // Optional: Show ram payer
    });

    let config = result.rows.filter((a) => a.collection_name === "ranchersland");

    while (result.more === true) {
      result = await fetchTable({
        json: true, // Get the response as json
        code: "atomicassets", // Contract that we target
        scope: wallet, // Account that owns the data
        table: "assets", // Table name
        lower_bound: result.next_key,
        limit: 1000, // Maximum number of rows that we want to get
        reverse: false, // Optional: Get reversed data
        show_payer: false, // Optional: Show ram payer
      });

      config.push(...result.rows.filter(a => a.collection_name === "ranchersland"));
    }

    if (config.length > 0) {
      return config.reverse();
    } else {
      return null;
    }
  } catch (err) {
    console.error(`[getAtomichubInventory] Error :`, err);
    return null;
  }
};



export const actClaimNFT = async (owner, asset_id) => {

  const wallet = localStorage.getItem("loggedInUser");
  const loginmethod = localStorage.getItem("loginMethod");

  if (!wallet || !loginmethod) {
    console.error("Need Login");
    return null;
  }


  try {
    let result;

    if (loginmethod === "cloud") {
      await ensureWaxApi();
      let actions = [
        {
          account: main_account,
          name: "claimnft",
          authorization: [
            {
              actor: wallet,
              permission: "active",
            },
          ],
          data: {
            wallet: wallet,
            owner: owner,
            asset_id: asset_id,
          },
        },
      ];
      result = await wax.api.transact(
        {
          actions: actions,
        },
        {
          blocksBehind: 3,
          expireSeconds: 1200,
        }
      );

      //console.log("Trx Completed:", result.transaction_id);
      const txid = result.transaction_id;
      const log = await getTransactionLog(txid);

      return {
        txid,
        log
      };

    } else {
      let session = await link.restoreSession("ranchersland");
      let actions = [
        {
          account: main_account,
          name: "claimnft",
          authorization: [
            {
              actor: wallet,
              permission: session.auth.permission,
            },
          ],
          data: {
            wallet: wallet,
            owner: owner,
            asset_id: asset_id,
          },
        },
      ];

      result = await session.transact(
        {
          actions: actions,
        },
        {
          blocksBehind: 3,
          expireSeconds: 1200,
        }
      );

      //console.log("🔍 Full Transaction Result:", result);

      const trxId = result?.processed?.id;

      // İlk ana aksiyonun inline aksiyonlarını çek
      const inlineTraces = result?.processed?.action_traces?.[0]?.inline_traces || [];

      // Tüm inline aksiyonları logla
      inlineTraces.forEach((trace, i) => {
        const name = trace?.act?.name;
        const data = trace?.act?.data;
        //console.log(`🔔 Inline Action ${i + 1}: ${name}`, data);
      });

      // notify varsa info mesajını çek
      const notify = inlineTraces.find(t => t.act?.name === "notify");
      const logInfo = notify?.act?.data?.info;

      //console.log("Trx Completed:", trxId);
      //console.log("🔔 Notify Log:", logInfo);

      return {
        txid: trxId,
        log: logInfo || []
      };
    }

  } catch (err) {
    console.error("Error:", err);
    const msg =
      err?.response?.json?.error?.details?.[0]?.message ||
      err?.message ||
      "Unknown transaction error occurred.";

    return { error: msg };
  }

};


export const actRepairNFT = async (owner, asset_id) => {

  const wallet = localStorage.getItem("loggedInUser");
  const loginmethod = localStorage.getItem("loginMethod");

  if (!wallet || !loginmethod) {
    console.error("Need Login");
    return null;
  }

  try {
    let result;

    if (loginmethod === "cloud") {
      await ensureWaxApi();
      let actions = [
        {
          account: main_account,
          name: "repair",
          authorization: [
            {
              actor: wallet,
              permission: "active",
            },
          ],
          data: {
            wallet: wallet,
            owner: owner,
            asset_id: asset_id,
          },
        },
      ];
      result = await wax.api.transact(
        {
          actions: actions,
        },
        {
          blocksBehind: 3,
          expireSeconds: 1200,
        }
      );

      //console.log("Trx Completed:", result.transaction_id);
      const txid = result.transaction_id;
      const log = await getTransactionLog(txid);

      return {
        txid,
        log
      };

    } else {
      let session = await link.restoreSession("ranchersland");
      let actions = [
        {
          account: main_account,
          name: "repair",
          authorization: [
            {
              actor: wallet,
              permission: session.auth.permission,
            },
          ],
          data: {
            wallet: wallet,
            owner: owner,
            asset_id: asset_id,
          },
        },
      ];

      result = await session.transact(
        {
          actions: actions,
        },
        {
          blocksBehind: 3,
          expireSeconds: 1200,
        }
      );

      //console.log("🔍 Full Transaction Result:", result);

      const trxId = result?.processed?.id;

      // İlk ana aksiyonun inline aksiyonlarını çek
      const inlineTraces = result?.processed?.action_traces?.[0]?.inline_traces || [];

      // Tüm inline aksiyonları logla
      inlineTraces.forEach((trace, i) => {
        const name = trace?.act?.name;
        const data = trace?.act?.data;
        //console.log(`🔔 Inline Action ${i + 1}: ${name}`, data);
      });

      // notify varsa info mesajını çek
      const notify = inlineTraces.find(t => t.act?.name === "notify");
      const logInfo = notify?.act?.data?.info;

      //console.log("Trx Completed:", trxId);
      //console.log("🔔 Notify Log:", logInfo);

      return {
        txid: trxId,
        log: logInfo || []
      };
    }

  } catch (err) {
    console.error("Error:", err);
    const msg =
      err?.response?.json?.error?.details?.[0]?.message ||
      err?.message ||
      "Unknown transaction error occurred.";

    return { error: msg };
  }

};


export const logout = async () => {

  localStorage.removeItem('loggedInUser');
  const loginmethod = localStorage.getItem("loginMethod");

  if (loginmethod === "cloud") {
    await wax.logout();
  }
  else {
    await link.clearSessions("ranchersland");
  }

  localStorage.removeItem('loginMethod');
};

export const actHealAsset = async (owner, asset_id) => {
  const wallet = localStorage.getItem("loggedInUser");
  const loginmethod = localStorage.getItem("loginMethod");

  if (!wallet || !loginmethod) {
    console.error("Need Login");
    return null;
  }

  try {
    let result;

    if (loginmethod === "cloud") {
      await ensureWaxApi();
      let actions = [
        {
          account: main_account,
          name: "inchealth",
          authorization: [
            {
              actor: wallet,
              permission: "active",
            },
          ],
          data: {
            wallet: wallet,
            owner: owner,
            asset_id: asset_id,
          },
        },
      ];
      result = await wax.api.transact(
        {
          actions: actions,
        },
        {
          blocksBehind: 3,
          expireSeconds: 1200,
        }
      );

      const txid = result.transaction_id;
      const log = await getTransactionLog(txid);

      return {
        txid,
        log
      };

    } else {
      let session = await link.restoreSession("ranchersland");
      let actions = [
        {
          account: main_account,
          name: "inchealth",
          authorization: [
            {
              actor: wallet,
              permission: session.auth.permission,
            },
          ],
          data: {
            wallet: wallet,
            owner: owner,
            asset_id: asset_id,
          },
        },
      ];

      result = await session.transact(
        {
          actions: actions,
        },
        {
          blocksBehind: 3,
          expireSeconds: 1200,
        }
      );

      const trxId = result?.processed?.id;

      const inlineTraces = result?.processed?.action_traces?.[0]?.inline_traces || [];

      inlineTraces.forEach((trace, i) => {
        const name = trace?.act?.name;
        const data = trace?.act?.data;
      });

      const notify = inlineTraces.find(t => t.act?.name === "notify");
      const logInfo = notify?.act?.data?.info;

      return {
        txid: trxId,
        log: logInfo || []
      };
    }

  } catch (err) {
    console.error("Error:", err);
    const msg =
      err?.response?.json?.error?.details?.[0]?.message ||
      err?.message ||
      "Unknown transaction error occurred.";

    return { error: msg };
  }
}

export const actClaimWorker = async (owner, asset_id) => {

  const wallet = localStorage.getItem("loggedInUser");
  const loginmethod = localStorage.getItem("loginMethod");

  if (!wallet || !loginmethod) {
    console.error("Need Login");
    return null;
  }


  try {
    let result;

    if (loginmethod === "cloud") {
      await ensureWaxApi();
      let actions = [
        {
          account: main_account,
          name: "claimworker",
          authorization: [
            {
              actor: wallet,
              permission: "active",
            },
          ],
          data: {
            wallet: wallet,
            owner: owner,
            asset_id: asset_id,
          },
        },
      ];
      result = await wax.api.transact(
        {
          actions: actions,
        },
        {
          blocksBehind: 3,
          expireSeconds: 1200,
        }
      );

      //console.log("Trx Completed:", result.transaction_id);
      const txid = result.transaction_id;
      const log = await getTransactionLog(txid);

      return {
        txid,
        log
      };

    } else {
      let session = await link.restoreSession("ranchersland");
      let actions = [
        {
          account: main_account,
          name: "claimworker",
          authorization: [
            {
              actor: wallet,
              permission: session.auth.permission,
            },
          ],
          data: {
            wallet: wallet,
            owner: owner,
            asset_id: asset_id,
          },
        },
      ];

      result = await session.transact(
        {
          actions: actions,
        },
        {
          blocksBehind: 3,
          expireSeconds: 1200,
        }
      );

      //console.log("🔍 Full Transaction Result:", result);

      const trxId = result?.processed?.id;

      // İlk ana aksiyonun inline aksiyonlarını çek
      const inlineTraces = result?.processed?.action_traces?.[0]?.inline_traces || [];

      // Tüm inline aksiyonları logla
      inlineTraces.forEach((trace, i) => {
        const name = trace?.act?.name;
        const data = trace?.act?.data;
        //console.log(`🔔 Inline Action ${i + 1}: ${name}`, data);
      });

      // notify varsa info mesajını çek
      const notify = inlineTraces.find(t => t.act?.name === "notify");
      const logInfo = notify?.act?.data?.info;

      //console.log("Trx Completed:", trxId);
      //console.log("🔔 Notify Log:", logInfo);

      return {
        txid: trxId,
        log: logInfo || []
      };
    }

  } catch (err) {
    console.error("Error:", err);
    const msg =
      err?.response?.json?.error?.details?.[0]?.message ||
      err?.message ||
      "Unknown transaction error occurred.";

    return { error: msg };
  }

};

export const actAddButton = async (owner, amount) => {

  const wallet = localStorage.getItem("loggedInUser");
  const loginmethod = localStorage.getItem("loginMethod");

  if (!wallet || !loginmethod) {
    console.error("Need Login");
    return null;
  }


  try {
    let result;

    if (loginmethod === "cloud") {
      await ensureWaxApi();
      let actions = [
        {
          account: main_account,
          name: "addenergy",
          authorization: [
            {
              actor: wallet,
              permission: "active",
            },
          ],
          data: {
            wallet: wallet,
            owner: owner,
            amount: amount,
          },
        },
      ];
      result = await wax.api.transact(
        {
          actions: actions,
        },
        {
          blocksBehind: 3,
          expireSeconds: 1200,
        }
      );

      //console.log("Trx Completed:", result.transaction_id);
      const txid = result.transaction_id;
      const log = await getTransactionLog(txid);

      return {
        txid,
        log
      };

    } else {
      let session = await link.restoreSession("ranchersland");
      let actions = [
        {
          account: main_account,
          name: "addenergy",
          authorization: [
            {
              actor: wallet,
              permission: session.auth.permission,
            },
          ],
          data: {
            wallet: wallet,
            owner: owner,
            amount: amount,
          },
        },
      ];

      result = await session.transact(
        {
          actions: actions,
        },
        {
          blocksBehind: 3,
          expireSeconds: 1200,
        }
      );

      //console.log("🔍 Full Transaction Result:", result);

      const trxId = result?.processed?.id;

      // İlk ana aksiyonun inline aksiyonlarını çek
      const inlineTraces = result?.processed?.action_traces?.[0]?.inline_traces || [];

      // Tüm inline aksiyonları logla
      inlineTraces.forEach((trace, i) => {
        const name = trace?.act?.name;
        const data = trace?.act?.data;
        //console.log(`🔔 Inline Action ${i + 1}: ${name}`, data);
      });

      // notify varsa info mesajını çek
      const notify = inlineTraces.find(t => t.act?.name === "notify");
      const logInfo = notify?.act?.data?.info;

      //console.log("Trx Completed:", trxId);
      //console.log("🔔 Notify Log:", logInfo);

      return {
        txid: trxId,
        log: logInfo || []
      };
    }

  } catch (err) {
    console.error("Error:", err);
    const msg =
      err?.response?.json?.error?.details?.[0]?.message ||
      err?.message ||
      "Unknown transaction error occurred.";

    return { error: msg };
  }

};

export const actCraftButton = async (template_id) => {

  const wallet = localStorage.getItem("loggedInUser");
  const loginmethod = localStorage.getItem("loginMethod");

  if (!wallet || !loginmethod) {
    console.error("Need Login");
    return null;
  }


  try {
    let result;

    if (loginmethod === "cloud") {
      await ensureWaxApi();
      let actions = [
        {
          account: main_account,
          name: "craft",
          authorization: [
            {
              actor: wallet,
              permission: "active",
            },
          ],
          data: {
            wallet: wallet,
            template_id: template_id,
          },
        },
      ];
      result = await wax.api.transact(
        {
          actions: actions,
        },
        {
          blocksBehind: 3,
          expireSeconds: 1200,
        }
      );

      //console.log("Trx Completed:", result.transaction_id);
      const txid = result.transaction_id;
      const log = await getTransactionLog(txid);

      return {
        txid,
        log
      };

    } else {
      let session = await link.restoreSession("ranchersland");
      let actions = [
        {
          account: main_account,
          name: "craft",
          authorization: [
            {
              actor: wallet,
              permission: session.auth.permission,
            },
          ],
          data: {
            wallet: wallet,
            template_id: template_id,
          },
        },
      ];

      result = await session.transact(
        {
          actions: actions,
        },
        {
          blocksBehind: 3,
          expireSeconds: 1200,
        }
      );

      //console.log("🔍 Full Transaction Result:", result);

      const trxId = result?.processed?.id;

      // İlk ana aksiyonun inline aksiyonlarını çek
      const inlineTraces = result?.processed?.action_traces?.[0]?.inline_traces || [];

      // Tüm inline aksiyonları logla
      inlineTraces.forEach((trace, i) => {
        const name = trace?.act?.name;
        const data = trace?.act?.data;
        //console.log(`🔔 Inline Action ${i + 1}: ${name}`, data);
      });

      // notify varsa info mesajını çek
      const notify = inlineTraces.find(t => t.act?.name === "notify");
      const logInfo = notify?.act?.data?.info;

      //console.log("Trx Completed:", trxId);
      //console.log("🔔 Notify Log:", logInfo);

      return {
        txid: trxId,
        log: logInfo || []
      };
    }

  } catch (err) {
    console.error("Error:", err);
    const msg =
      err?.response?.json?.error?.details?.[0]?.message ||
      err?.message ||
      "Unknown transaction error occurred.";

    return { error: msg };
  }

};

export const actStakeNFT = async (asset_id) => {

  const wallet = localStorage.getItem("loggedInUser");
  const loginmethod = localStorage.getItem("loginMethod");

  if (!wallet || !loginmethod) {
    console.error("Need Login");
    return null;
  }


  try {
    let result;

    if (loginmethod === "cloud") {
      await ensureWaxApi();
      let actions = [
        {
          account: "atomicassets",
          name: "transfer",
          authorization: [
            {
              actor: wallet,
              permission: "active",
            },
          ],
          data: {
            from: wallet,
            to: "ranchersland",
            asset_ids: [asset_id],
            memo: "Stake NFT",
          },
        },
      ];
      result = await wax.api.transact(
        {
          actions: actions,
        },
        {
          blocksBehind: 3,
          expireSeconds: 1200,
        }
      );

      //console.log("Trx Completed:", result.transaction_id);
      const txid = result.transaction_id;
      const log = await getTransactionLog(txid);

      return {
        txid,
        log
      };

    } else {
      let session = await link.restoreSession("ranchersland");
      let actions = [
        {
          account: "atomicassets",
          name: "transfer",
          authorization: [
            {
              actor: wallet,
              permission: session.auth.permission,
            },
          ],
          data: {
            from: wallet,
            to: "ranchersland",
            asset_ids: [asset_id],
            memo: "Stake NFT",
          },
        },
      ];

      result = await session.transact(
        {
          actions: actions,
        },
        {
          blocksBehind: 3,
          expireSeconds: 1200,
        }
      );

      //console.log("🔍 Full Transaction Result:", result);

      const trxId = result?.processed?.id;

      // İlk ana aksiyonun inline aksiyonlarını çek
      const inlineTraces = result?.processed?.action_traces?.[0]?.inline_traces || [];

      // Tüm inline aksiyonları logla
      inlineTraces.forEach((trace, i) => {
        const name = trace?.act?.name;
        const data = trace?.act?.data;
        //console.log(`🔔 Inline Action ${i + 1}: ${name}`, data);
      });

      // notify varsa info mesajını çek
      const notify = inlineTraces.find(t => t.act?.name === "notify");
      const logInfo = notify?.act?.data?.info;

      //console.log("Trx Completed:", trxId);
      //console.log("🔔 Notify Log:", logInfo);

      return {
        txid: trxId,
        log: logInfo || []
      };
    }

  } catch (err) {
    console.error("Error:", err);
    const msg =
      err?.response?.json?.error?.details?.[0]?.message ||
      err?.message ||
      "Unknown transaction error occurred.";

    return { error: msg };
  }

};


export const actUnstakeNFT = async (asset_id) => {

  const wallet = localStorage.getItem("loggedInUser");
  const loginmethod = localStorage.getItem("loginMethod");

  if (!wallet || !loginmethod) {
    console.error("Need Login");
    return null;
  }


  try {
    let result;

    if (loginmethod === "cloud") {
      await ensureWaxApi();
      let actions = [
        {
          account: main_account,
          name: "unstake",
          authorization: [
            {
              actor: wallet,
              permission: "active",
            },
          ],
          data: {
            wallet: wallet,
            asset_id: asset_id,
          },
        },
      ];
      result = await wax.api.transact(
        {
          actions: actions,
        },
        {
          blocksBehind: 3,
          expireSeconds: 1200,
        }
      );

      //console.log("Trx Completed:", result.transaction_id);
      const txid = result.transaction_id;
      const log = await getTransactionLog(txid);

      return {
        txid,
        log
      };

    } else {
      let session = await link.restoreSession("ranchersland");
      let actions = [
        {
          account: main_account,
          name: "unstake",
          authorization: [
            {
              actor: wallet,
              permission: session.auth.permission,
            },
          ],
          data: {
            wallet: wallet,
            asset_id: asset_id,
          },
        },
      ];

      result = await session.transact(
        {
          actions: actions,
        },
        {
          blocksBehind: 3,
          expireSeconds: 1200,
        }
      );

      //console.log("🔍 Full Transaction Result:", result);

      const trxId = result?.processed?.id;

      // İlk ana aksiyonun inline aksiyonlarını çek
      const inlineTraces = result?.processed?.action_traces?.[0]?.inline_traces || [];

      // Tüm inline aksiyonları logla
      inlineTraces.forEach((trace, i) => {
        const name = trace?.act?.name;
        const data = trace?.act?.data;
        //console.log(`🔔 Inline Action ${i + 1}: ${name}`, data);
      });

      // notify varsa info mesajını çek
      const notify = inlineTraces.find(t => t.act?.name === "notify");
      const logInfo = notify?.act?.data?.info;

      //console.log("Trx Completed:", trxId);
      //console.log("🔔 Notify Log:", logInfo);

      return {
        txid: trxId,
        log: logInfo || []
      };
    }

  } catch (err) {
    console.error("Error:", err);
    const msg =
      err?.response?.json?.error?.details?.[0]?.message ||
      err?.message ||
      "Unknown transaction error occurred.";

    return { error: msg };
  }

};


export const actRegister = async (referrer = null) => {

  const wallet = localStorage.getItem("loggedInUser");
  const loginmethod = localStorage.getItem("loginMethod");

  if (!wallet || !loginmethod) {
    console.error("Need Login");
    return null;
  }


  try {
    let result;

    if (loginmethod === "cloud") {
      await ensureWaxApi();

      let actions = [
        {
          account: main_account,
          name: "newuser",
          authorization: [
            {
              actor: wallet,
              permission: "active",
            },
          ],
          data: referrer
            ? { wallet: wallet, ref: referrer }
            : { wallet: wallet, ref: "" },
        },
      ];
      result = await wax.api.transact(
        {
          actions: actions,
        },
        {
          blocksBehind: 3,
          expireSeconds: 1200,
        }
      );

      //console.log("Trx Completed:", result.transaction_id);
      const txid = result.transaction_id;
      const log = await getTransactionLog(txid);

      return {
        txid,
        log
      };

    } else {
      let session = await link.restoreSession("ranchersland");
      let actions = [
        {
          account: main_account,
          name: "newuser",
          authorization: [
            {
              actor: wallet,
              permission: session.auth.permission,
            },
          ],
          data: referrer
            ? { wallet: wallet, ref: referrer }
            : { wallet: wallet, ref: "" },
        },
      ];

      result = await session.transact(
        {
          actions: actions,
        },
        {
          blocksBehind: 3,
          expireSeconds: 1200,
        }
      );

      //console.log("🔍 Full Transaction Result:", result);

      const trxId = result?.processed?.id;

      // İlk ana aksiyonun inline aksiyonlarını çek
      const inlineTraces = result?.processed?.action_traces?.[0]?.inline_traces || [];

      // Tüm inline aksiyonları logla
      inlineTraces.forEach((trace, i) => {
        const name = trace?.act?.name;
        const data = trace?.act?.data;
        //console.log(`🔔 Inline Action ${i + 1}: ${name}`, data);
      });

      // notify varsa info mesajını çek
      const notify = inlineTraces.find(t => t.act?.name === "notify");
      const logInfo = notify?.act?.data?.info;

      //console.log("Trx Completed:", trxId);
      //console.log("🔔 Notify Log:", logInfo);

      return {
        txid: trxId,
        log: logInfo || []
      };
    }

  } catch (err) {
    console.error("Error:", err);
    const msg =
      err?.response?.json?.error?.details?.[0]?.message ||
      err?.message ||
      "Unknown transaction error occurred.";

    return { error: msg };
  }

};


export const actWithdraw = async (quantity) => {

  const wallet = localStorage.getItem("loggedInUser");
  const loginmethod = localStorage.getItem("loginMethod");

  if (!wallet || !loginmethod) {
    console.error("Need Login");
    return null;
  }


  try {
    let result;

    if (loginmethod === "cloud") {
      await ensureWaxApi();
      let actions = [
        {
          account: main_account,
          name: "withdraw",
          authorization: [
            {
              actor: wallet,
              permission: "active",
            },
          ],
          data: {
            wallet: wallet,
            quantity: quantity,
          },
        },
      ];
      result = await wax.api.transact(
        {
          actions: actions,
        },
        {
          blocksBehind: 3,
          expireSeconds: 1200,
        }
      );

      //console.log("Trx Completed:", result.transaction_id);
      const txid = result.transaction_id;
      const log = await getTransactionLog(txid);

      return {
        txid,
        log
      };

    } else {
      let session = await link.restoreSession("ranchersland");
      let actions = [
        {
          account: main_account,
          name: "withdraw",
          authorization: [
            {
              actor: wallet,
              permission: session.auth.permission,
            },
          ],
          data: {
            wallet: wallet,
            quantity: quantity,
          },
        },
      ];

      result = await session.transact(
        {
          actions: actions,
        },
        {
          blocksBehind: 3,
          expireSeconds: 1200,
        }
      );

      //console.log("🔍 Full Transaction Result:", result);

      const trxId = result?.processed?.id;

      // İlk ana aksiyonun inline aksiyonlarını çek
      const inlineTraces = result?.processed?.action_traces?.[0]?.inline_traces || [];

      // Tüm inline aksiyonları logla
      inlineTraces.forEach((trace, i) => {
        const name = trace?.act?.name;
        const data = trace?.act?.data;
        //console.log(`🔔 Inline Action ${i + 1}: ${name}`, data);
      });

      // notify varsa info mesajını çek
      const notify = inlineTraces.find(t => t.act?.name === "notify");
      const logInfo = notify?.act?.data?.info;

      //console.log("Trx Completed:", trxId);
      //console.log("🔔 Notify Log:", logInfo);

      return {
        txid: trxId,
        log: logInfo || []
      };
    }

  } catch (err) {
    console.error("Error:", err);
    const msg =
      err?.response?.json?.error?.details?.[0]?.message ||
      err?.message ||
      "Unknown transaction error occurred.";

    return { error: msg };
  }

};

export const actDeposit = async (quantity) => {

  const wallet = localStorage.getItem("loggedInUser");
  const loginmethod = localStorage.getItem("loginMethod");

  if (!wallet || !loginmethod) {
    console.error("Need Login");
    return null;
  }


  try {
    let result;

    if (loginmethod === "cloud") {
      await ensureWaxApi();
      let actions = [
        {
          account: token_account,
          name: "transfers",
          authorization: [
            {
              actor: wallet,
              permission: "active",
            },
          ],
          data: {
            from: wallet,
            to: main_account,
            quantity: quantity,
            memo: "Deposit"
          },
        },
      ];
      result = await wax.api.transact(
        {
          actions: actions,
        },
        {
          blocksBehind: 3,
          expireSeconds: 1200,
        }
      );

      //console.log("Trx Completed:", result.transaction_id);
      const txid = result.transaction_id;
      const log = await getTransactionLog(txid);

      return {
        txid,
        log
      };

    } else {
      let session = await link.restoreSession("ranchersland");
      let actions = [
        {
          account: token_account,
          name: "transfers",
          authorization: [
            {
              actor: wallet,
              permission: session.auth.permission,
            },
          ],
          data: {
            from: wallet,
            to: main_account,
            quantity: quantity,
            memo: "Deposit"
          },
        },
      ];

      result = await session.transact(
        {
          actions: actions,
        },
        {
          blocksBehind: 3,
          expireSeconds: 1200,
        }
      );

      //console.log("🔍 Full Transaction Result:", result);

      const trxId = result?.processed?.id;

      // İlk ana aksiyonun inline aksiyonlarını çek
      const inlineTraces = result?.processed?.action_traces?.[0]?.inline_traces || [];

      // Tüm inline aksiyonları logla
      inlineTraces.forEach((trace, i) => {
        const name = trace?.act?.name;
        const data = trace?.act?.data;
        //console.log(`🔔 Inline Action ${i + 1}: ${name}`, data);
      });

      // notify varsa info mesajını çek
      const notify = inlineTraces.find(t => t.act?.name === "notify");
      const logInfo = notify?.act?.data?.info;

      //console.log("Trx Completed:", trxId);
      //console.log("🔔 Notify Log:", logInfo);

      return {
        txid: trxId,
        log: logInfo || []
      };
    }

  } catch (err) {
    console.error("Error:", err);
    const msg =
      err?.response?.json?.error?.details?.[0]?.message ||
      err?.message ||
      "Unknown transaction error occurred.";

    return { error: msg };
  }

};

export const actSetAssistance = async (account) => {

  const wallet = localStorage.getItem("loggedInUser");
  const loginmethod = localStorage.getItem("loginMethod");

  if (!wallet || !loginmethod) {
    console.error("Need Login");
    return null;
  }


  try {
    let result;

    if (loginmethod === "cloud") {
      await ensureWaxApi();
      let actions = [
        {
          account: main_account,
          name: "setassistant",
          authorization: [
            {
              actor: wallet,
              permission: "active",
            },
          ],
          data: {
            wallet: wallet,
            assistant_account: account,
          },
        },
      ];
      result = await wax.api.transact(
        {
          actions: actions,
        },
        {
          blocksBehind: 3,
          expireSeconds: 1200,
        }
      );

      //console.log("Trx Completed:", result.transaction_id);
      const txid = result.transaction_id;
      const log = await getTransactionLog(txid);

      return {
        txid,
        log
      };

    } else {
      let session = await link.restoreSession("ranchersland");
      let actions = [
        {
          account: main_account,
          name: "setassistant",
          authorization: [
            {
              actor: wallet,
              permission: session.auth.permission,
            },
          ],
          data: {
            wallet: wallet,
            assistant_account: account,
          },
        },
      ];

      result = await session.transact(
        {
          actions: actions,
        },
        {
          blocksBehind: 3,
          expireSeconds: 1200,
        }
      );

      //console.log("🔍 Full Transaction Result:", result);

      const trxId = result?.processed?.id;

      // İlk ana aksiyonun inline aksiyonlarını çek
      const inlineTraces = result?.processed?.action_traces?.[0]?.inline_traces || [];

      // Tüm inline aksiyonları logla
      inlineTraces.forEach((trace, i) => {
        const name = trace?.act?.name;
        const data = trace?.act?.data;
        //console.log(`🔔 Inline Action ${i + 1}: ${name}`, data);
      });

      // notify varsa info mesajını çek
      const notify = inlineTraces.find(t => t.act?.name === "notify");
      const logInfo = notify?.act?.data?.info;

      //console.log("Trx Completed:", trxId);
      //console.log("🔔 Notify Log:", logInfo);

      return {
        txid: trxId,
        log: logInfo || []
      };
    }

  } catch (err) {
    console.error("Error:", err);
    const msg =
      err?.response?.json?.error?.details?.[0]?.message ||
      err?.message ||
      "Unknown transaction error occurred.";

    return { error: msg };
  }

};

export const actSetMyref = async (account) => {

  const wallet = localStorage.getItem("loggedInUser");
  const loginmethod = localStorage.getItem("loginMethod");

  if (!wallet || !loginmethod) {
    console.error("Need Login");
    return null;
  }


  try {
    let result;

    if (loginmethod === "cloud") {
      await ensureWaxApi();
      let actions = [
        {
          account: main_account,
          name: "setmyref",
          authorization: [
            {
              actor: wallet,
              permission: "active",
            },
          ],
          data: {
            wallet: wallet,
            myref: account,
          },
        },
      ];
      result = await wax.api.transact(
        {
          actions: actions,
        },
        {
          blocksBehind: 3,
          expireSeconds: 1200,
        }
      );

      //console.log("Trx Completed:", result.transaction_id);
      const txid = result.transaction_id;
      const log = await getTransactionLog(txid);

      return {
        txid,
        log
      };

    } else {
      let session = await link.restoreSession("ranchersland");
      let actions = [
        {
          account: main_account,
          name: "setmyref",
          authorization: [
            {
              actor: wallet,
              permission: session.auth.permission,
            },
          ],
          data: {
            wallet: wallet,
            myref: account,
          },
        },
      ];

      result = await session.transact(
        {
          actions: actions,
        },
        {
          blocksBehind: 3,
          expireSeconds: 1200,
        }
      );

      //console.log("🔍 Full Transaction Result:", result);

      const trxId = result?.processed?.id;

      // İlk ana aksiyonun inline aksiyonlarını çek
      const inlineTraces = result?.processed?.action_traces?.[0]?.inline_traces || [];

      // Tüm inline aksiyonları logla
      inlineTraces.forEach((trace, i) => {
        const name = trace?.act?.name;
        const data = trace?.act?.data;
        //console.log(`🔔 Inline Action ${i + 1}: ${name}`, data);
      });

      // notify varsa info mesajını çek
      const notify = inlineTraces.find(t => t.act?.name === "notify");
      const logInfo = notify?.act?.data?.info;

      //console.log("Trx Completed:", trxId);
      //console.log("🔔 Notify Log:", logInfo);

      return {
        txid: trxId,
        log: logInfo || []
      };
    }

  } catch (err) {
    console.error("Error:", err);
    const msg =
      err?.response?.json?.error?.details?.[0]?.message ||
      err?.message ||
      "Unknown transaction error occurred.";

    return { error: msg };
  }

};

export const actVote = async () => {

  const wallet = localStorage.getItem("loggedInUser");
  const loginmethod = localStorage.getItem("loginMethod");

  if (!wallet || !loginmethod) {
    console.error("Need Login");
    return null;
  }

  try {
    let result;

    if (loginmethod === "cloud") {
      await ensureWaxApi();
      let actions = [
        {
          account: "eosio",
          name: "voteproducer",
          authorization: [
            {
              actor: wallet,
              permission: "active",
            },
          ],
          data: {
            voter: wallet,
            proxy: "ranchersland",
            producers: [],
          },
        },
      ];
      result = await wax.api.transact(
        {
          actions: actions,
        },
        {
          blocksBehind: 3,
          expireSeconds: 1200,
        }
      );

      //console.log("Trx Completed:", result.transaction_id);
      const txid = result.transaction_id;
      const log = await getTransactionLog(txid);

      return {
        txid,
        log
      };

    } else {
      let session = await link.restoreSession("ranchersland");
      let actions = [
        {
          account: "eosio",
          name: "voteproducer",
          authorization: [
            {
              actor: wallet,
              permission: session.auth.permission,
            },
          ],
          data: {
            voter: wallet,
            proxy: "ranchersland",
            producers: [],
          },
        },
      ];

      result = await session.transact(
        {
          actions: actions,
        },
        {
          blocksBehind: 3,
          expireSeconds: 1200,
        }
      );

      //console.log("🔍 Full Transaction Result:", result);

      const trxId = result?.processed?.id;

      return {
        txid: trxId,
        log: []
      };
    }

  } catch (err) {
    console.error("Error:", err);
    const msg =
      err?.response?.json?.error?.details?.[0]?.message ||
      err?.message ||
      "Unknown transaction error occurred.";

    return { error: msg };
  }

};


